import { createSuitMixin as t } from "../mixins/suit.js";
import { createWidgetMixin as e } from "../mixins/widget.js";
import { connectStats as s } from "instantsearch.js/es/connectors/index.js";
export default {
  name: "AisStats",
  mixins: [e({
    connector: s
  }, {
    $$widgetType: "ais.stats"
  }), t({
    name: "Stats"
  })],
  computed: {
    sortedResultsSentence: function sortedResultsSentence() {
      var t = this.state,
          e = t.nbHits,
          s = t.nbSortedHits,
          r = "sorted out of " + e.toLocaleString();
      return 0 === s ? "No relevant results " + r : 1 === s ? "1 relevant result " + r : s > 1 ? (s || 0).toLocaleString() + " relevant results " + r : "";
    },
    resultsSentence: function resultsSentence() {
      var t = this.state.nbHits;
      return 0 === t ? "No results" : 1 === t ? "1 result" : t > 1 ? t.toLocaleString() + " results" : "";
    },
    widgetParams: function widgetParams() {
      return {};
    }
  }
};